import { GridCellProps } from '@progress/kendo-react-grid';
import { Input } from '@progress/kendo-react-inputs';

export const NoSpinNumericCell = (
  props: React.PropsWithChildren<GridCellProps>
) => {
  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  };

  return (
    <td>
      <Input
        className="noscroll"
        type="number"
        style={{ textAlign: 'right' }}
        min={0}
        step="any"
        value={parseFloat(props.dataItem?.measuredValue?.toFixed(4)) ?? null}
        onChange={event => {
          props.onChange?.call(this, {
            dataItem: props.dataItem,
            dataIndex: props.dataIndex,
            field: props.field,
            value: parseFloat(event.value),
            syntheticEvent: event.syntheticEvent
          });
        }}
        onKeyDown={onKeyDown}
      />
    </td>
  );
};
